<template lang="pug">
div
  BriqDataTable(
    :data='tableData || []'
    :filter='filter'
    :initialSort="initialSort"
    :loading='isFetching'
    @click='viewBooking'
    @rightClick='rightClick'
  )
  BriqDataTableActionMenu(
    v-if='showContextMenu'
    :item='actionMenuItem'
    :top='actionMenuTop'
    :left='actionMenuLeft'
    :loading='actionMenuLoading'
    @close='closeActionMenu'
    @openBriqDialog='openBriqDialog'
  )
  BriqDialog(v-if='showBriqDialog' @close='closeBriqDialog')
    component(
      :is='activeDialog.dialog'
      :booking='activeDialog.booking'
      @close='closeBriqDialog'
      @reloadBookings='reloadBookings'
    )
</template>

<script>
import { mapGetters } from 'vuex'
import { fromUtc } from '@/helpers/dateTimeFormatter.js'
import BriqDataTable from '@/vue/components/BriqDataTable.vue'
import BriqDataTableActionMenu from './action-menu/BriqDataTableActionMenu.vue'
import BriqDialog from '@/vue/components-global/BriqDialog.vue'
import RegisterPaymentDialog from './dialogs/RegisterPaymentDialog.vue'
import ResendMailDialog from './dialogs/ResendMailDialog.vue'
import NoShowDialog from './dialogs/NoShowDialog.vue'
import CancelBookingDialog from './dialogs/CancelBookingDialog.vue'

export default {
  name: 'BookingsOverviewTable',
  components: {
    BriqDataTable,
    BriqDataTableActionMenu,
    BriqDialog,
    RegisterPaymentDialog,
    ResendMailDialog,
    NoShowDialog,
    CancelBookingDialog,
  },
  data() {
    return {
      showContextMenu: false,
      actionMenuItem: null,
      actionMenuTop: 0,
      actionMenuLeft: 0,
      actionMenuLoading: false,
      showBriqDialog: false,
      activeDialog: null,
    }
  },
  methods: {
    viewBooking(booking) {
      const key = booking.item.Key
      const url = `${window.location.origin}/bookings/${key}/details`
      window.location.href = url
    },
    getAmountCustomField(row, columnValue) {
      const isInvoiced =
        row.CurrentBillingMethod &&
        (row.CurrentBillingMethod === 'InvoiceNow' || row.CurrentBillingMethod === 'InvoiceAfter')
      const display = this.getCurrencyFormat(columnValue, row.CurrencyCode)
      const hasAmountOpen = row.AmountTotal - row.AmountPaid > 0
      if (isInvoiced) return `<div>${display} <span style="color: orange;">(Invoice)</span></div>`
      if (hasAmountOpen) return `<span style="color: orange;">${display}</span>`
      return `<span style="color: green;">${display}</span>`
    },
    getDateCustomField(_, date) {
      return date ? fromUtc()(this.$locale || 'nl-NL')(this.$timezone)(date) : ''
    },
    getCurrencyFormat(value, currency) {
      return new Intl.NumberFormat(this.$locale, {
        style: 'currency',
        currency,
      }).format(value)
    },
    rightClick(event, item) {
      this.actionMenuItem = item
      this.actionMenuTop = event.pageY - 10
      this.actionMenuLeft = event.pageX - 10
      this.showContextMenu = true
    },
    closeActionMenu() {
      this.showContextMenu = false
      this.actionMenuItem = null
      this.actionMenuTop = 0
      this.actionMenuLeft = 0
      this.actionMenuLoading = false
    },
    async openBriqDialog(dialog, booking) {
      this.actionMenuLoading = true
      await this.$store.dispatch('bookingDetails/fetchBookingDetails', booking.Key)
      this.closeActionMenu()
      this.showBriqDialog = true
      this.activeDialog = {
        dialog,
        booking,
      }
      this.actionMenuLoading = false
    },
    closeBriqDialog() {
      this.showBriqDialog = false
      this.activeDialog = null
      this.actionMenuLoading = false
    },
    reloadBookings() {
      this.$store.dispatch('bookings/fetchBookings')
    },
    async sortWithAPI(header, direction) {
      await this.$store.dispatch('bookings/sortWithAPI', {
        field: header.sortKey || header.field,
        direction,
      })
      this.$store.commit('bookings/setBookings', [])
      this.$store.dispatch('bookings/fetchBookings')
    },
  },
  computed: {
    ...mapGetters('bookings', ['initialSort', 'bookings', 'filters', 'isFetching', 'filterQueryString']),
    tableData() {
      return {
        items: this.bookings || [],
        headers: [
          {
            field: 'DatetimeUTC',
            label: 'Date of booking',
            sortKey: 'DatetimeUTC',
            onSort: (header, direction) => this.sortWithAPI(header, direction),
            customField: (row, columnValue) => this.getDateCustomField(row, columnValue),
          },
          {
            field: 'StartTime',
            label: 'Date of visit',
            sortKey: 'StartTime',
            onSort: (header, direction) => this.sortWithAPI(header, direction),
            customField: (row, columnValue) => this.getDateCustomField(row, columnValue),
          },
          {
            field: 'Number',
            label: 'Booking',
            onSort: (header, direction) => this.sortWithAPI(header, direction),
          },
          {
            field: 'FullName',
            label: 'Customer',
            sortKey: 'CustomerFirstName',
            onSort: (header, direction) => this.sortWithAPI(header, direction),
          },
          {
            field: 'CompanyName',
            label: 'Company',
            onSort: (header, direction) => this.sortWithAPI(header, direction),
          },
          {
            field: 'NumberOfPersons',
            label: 'Visitors',
            onSort: (header, direction) => this.sortWithAPI(header, direction),
          },
          {
            field: 'AmountTotal',
            label: 'Amount',
            onSort: (header, direction) => this.sortWithAPI(header, direction),
            customField: (row, columnValue) => this.getAmountCustomField(row, columnValue),
          },
          {
            field: 'CurrentStatusCode',
            label: 'Booking Status',
            onSort: (header, direction) => this.sortWithAPI(header, direction),
          },
          { field: 'AttendanceStatus', label: 'Attendance', sortable: false },
          { field: 'Origin', label: 'Origin', sortable: false },
        ],
      }
    },
  }
}
</script>
